import PropTypes from 'prop-types';
import styled from 'styled-components';

import type { CommonProps, LayoutProps } from './constants';
import { COMMON, LAYOUT } from './constants';
import theme from './theme';

type Props = CommonProps & LayoutProps;

const Box = styled.div<Props>`
  ${LAYOUT} ${COMMON};
`;

Box.defaultProps = { theme };

Box.propTypes = {
  ...LAYOUT.propTypes,
  ...COMMON.propTypes,
  theme: PropTypes.object, // eslint-disable-line react/forbid-prop-types
};

Box.displayName = 'Box';

export { Box };
